import { setLoginRedirect } from '@/logic/loginRedirect'

let acceptanceCounter = 0

export function requiresLegalConfirmation(user) {
  if (!user) {
    return false
  }

  const requiresTosAcceptance = !user.tos_accepted
  const requiresPrivacyPolicyAcceptance = user.privacy_policy_required && !user.privacy_policy_accepted

  return requiresTosAcceptance || requiresPrivacyPolicyAcceptance
}

export function requiresLegalReconfirmation(user) {
  if (!user) {
    return false
  }

  const requiresTosReconfirmation = !user.tos_accepted && user.tos_acceptance_status === 'previous'
  const requiresPrivacyPolicyReconfirmation = user.privacy_policy_required
    && !user.privacy_policy_accepted
    && user.privacy_policy_acceptance_status === 'previous'

  return requiresTosReconfirmation || requiresPrivacyPolicyReconfirmation
}

export function getLegalAcceptanceCounter() {
  return acceptanceCounter
}

export function recordLegalAcceptance(acceptance) {
  if (acceptance && !requiresLegalConfirmation(acceptance)) {
    acceptanceCounter += 1
  }
}

export function redirectToLegalConfirmation(router, counterAtRequest) {
  // Denials from requests started before completed acceptance must not send the learner back.
  if (counterAtRequest !== acceptanceCounter) {
    return
  }
  const route = router.currentRoute
  if (route.meta.requiresAuth === false || route.name === 'auth.tos' || route.name === 'auth.logout') {
    return
  }
  setLoginRedirect(route.fullPath)
  router.replace({ name: 'auth.tos' }, () => {})
}
